import Box from '@zenbusiness/zui/Box';
import { styled } from '@zenbusiness/zui/styles';

export const WrapperStyle = ({ theme }) => ({
  gridColumn: '1 / 5',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    gridColumn: '1 / 7'
  },
  [theme.breakpoints.up('md')]: {
    gridColumn: '4 / 10'
  }
});

export const Wrapper = styled(Box)(WrapperStyle);
